// Un solo build por ambiente: VITE_APP_MODE=qa produce la consola reducida del
// ambiente de pruebas; cualquier otro valor es la consola de producción.
export const isQaMode = import.meta.env.VITE_APP_MODE === "qa";

// A dónde lleva "Entra desde tu consola de producción" en la pantalla de QA.
export const PRODUCTION_CONSOLE_URL = (
  import.meta.env.VITE_PRODUCTION_CONSOLE_URL || "/"
).replace(/\/+$/, "");

// Rutas de la consola de QA. Todo lo demás (compras, tienda, administración de
// plataforma, registro, contraseñas) no existe en el ambiente de pruebas y
// redirige al inicio.
export const QA_ROUTE_NAMES = new Set([
  "Login",
  "QaAccess",
  "PrivacyNotice",
  "Dashboard",
  "NewSignature",
  "Tokens",
  "Documents",
  "Settings",
]);
